import { render, staticRenderFns } from "./ContactContent.vue?vue&type=template&id=0f981faa&scoped=true&"
import script from "./ContactContent.vue?vue&type=script&lang=js&"
export * from "./ContactContent.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all.css?vue&type=style&index=0&id=0f981faa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f981faa",
  null
  
)

export default component.exports